export const replaceKeysWithExamples = (
  template: string | undefined,
  keysData: { key: string; example: string; valueType: string }[]
) => {
  const map = Object.fromEntries(
    keysData.map((item) => [
      item.key,
      { example: item.example, valueType: item.valueType }
    ])
  )

  return (template || "")
    .replace(/\{\{(\w+)\}\}/g, (match, key) => {
      const data = map[key]

      if (!data) return match

      const { example, valueType } = data

      return valueType === "link"
        ? `<a href="" class="example-preview-dynamic-tag" style="pointer-events:none">${example}</a>`
        : `<span class="example-preview-dynamic-tag">${example}</span>`
    })
    .replace(/\s*editor-dynamic-tag_closed/g, "")
    .replace(/\s*editor-dynamic-tag/g, "")
}

export const getInnerText = (html: string) => html.replace(/<[^>]*>/g, "")
